<ng-template #drawerContent>
	<div class="overflow-y-auto">
		<pdp-product-availability-notification-form
			[sku]="resolvedSku()"
			[productTitle]="product()?.name"
			[productECode]="product()?.partNumber"
			[storeDetails]="storeDetails()"
			[shipMode]="shipMode()"
			(panelClosed)="closeDrawer()">
		</pdp-product-availability-notification-form>
	</div>
</ng-template>
